import React, { useState, useEffect } from 'react';
import './DemoGuide.css';

const DEMO_STEPS = [
  {
    step: 1,
    title: 'Stap 1: Producten kiezen',
    body: 'Selecteer één of meerdere producten uit de lijst door op een productkaart te klikken. Klik daarna op de knop "Doorgaan" onderaan.',
    target: 'demo-step-1'
  },
  {
    step: 2,
    title: 'Stap 2: AI-informatie (optioneel)',
    body: 'U kunt hier extra informatie invoeren voor de offerte. In de demo kunt u dit overslaan met "Sla over → Direct naar Volgende Stap".',
    target: 'demo-step-2'
  },
  {
    step: 3,
    title: 'Stap 3: Klant selecteren',
    body: 'Kies een klant uit de lijst of vul handmatig gegevens in. Klik op "Doorgaan naar Offerte" om naar de offertebouwer te gaan.',
    target: 'demo-step-3'
  },
  {
    step: 4,
    title: 'Stap 4: Offerte invullen',
    body: 'Pas de teksten aan. Klik op "Genereer teksten met AI" voor standaardteksten. Controleer de algemene voorwaarden en ondertekening. Ga daarna naar "Bekijk voorbeeld".',
    target: 'demo-step-4'
  },
  {
    step: 5,
    title: 'Stap 5: Voorbeeld en opslaan',
    body: 'Bekijk het voorbeeld van de offerte. Klik op "Opslaan" om de offerte op te slaan (in de demo zonder inlog). Daarna kunt u doorgaan naar de PDF-stap.',
    target: 'demo-step-5'
  },
  {
    step: 6,
    title: 'Stap 6: PDF genereren',
    body: 'Genereer en download de offerte als PDF. In de demo wordt een voorbeeld-PDF gegenereerd.',
    target: 'demo-step-6'
  },
  {
    step: 7,
    title: 'Demo afgerond',
    body: 'U heeft de flow doorlopen. Registreer een account om met uw eigen Odoo en gegevens te werken.',
    target: 'demo-step-7'
  }
];

export default function DemoGuide({ currentStep, onNext }) {
  const [targetRect, setTargetRect] = useState(null);
  const [visible, setVisible] = useState(true);

  const config = DEMO_STEPS.find(s => s.step === currentStep);
  const isLast = currentStep >= 7;

  useEffect(() => {
    setVisible(true);
  }, [currentStep]);

  useEffect(() => {
    if (!config?.target) {
      setTargetRect(null);
      return;
    }
    const el = document.querySelector(`[data-demo-step="${config.target}"]`);
    if (el) {
      const rect = el.getBoundingClientRect();
      setTargetRect(rect);
    } else {
      setTargetRect(null);
    }
  }, [currentStep, config?.target]);

  const handleNext = () => {
    setVisible(false);
    if (onNext) onNext();
  };

  if (!config || !visible) return null;

  return (
    <div className="demo-guide-overlay" role="dialog" aria-label="Demo-uitleg">
      {targetRect && (
        <div
          className="demo-guide-spotlight"
          style={{
            top: targetRect.top - 8,
            left: targetRect.left - 8,
            width: targetRect.width + 16,
            height: targetRect.height + 16
          }}
        />
      )}
      <div className="demo-guide-card">
        <p className="demo-guide-hint">De pijl wijst naar wat u moet doen ↓</p>
        <h3 className="demo-guide-title">{config.title}</h3>
        <p className="demo-guide-body">{config.body}</p>
        <button type="button" className="btn btn-primary demo-guide-next" onClick={handleNext}>
          {isLast ? 'Sluiten' : 'Volgende'}
        </button>
      </div>
    </div>
  );
}
